import React, { Component } from 'react';
import Navbar from './Navbar';
import Slider from './Slider';
import Certificates from './Certificates';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import './WorkPage.css';

const CertificatesPage = props => (

		<section className="container work-section" id="work">    
      {/*<div className="project-about" id="about">
            <img className="loga-about" src="loga_gotowe.jpg" alt="loga" />
            <p>
               Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą inwestycji technologicznej
               polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food.
            </p>
            <p>
               Celem przedsięwzięcia jest trwała poprawa konkurencyjności przedsiębiorstwa HADEPOL FLEXO Sp. z o.o. na krajowym
               i zagranicznym rynku opakowań poprzez wdrożenie innowacji technologicznych w obszarze wytwarzania opakowań papierowych powlekanych.
               Efektem realizacji projektu będzie wdrożenie innowacji procesowej nie znanej do tej pory na świecie oraz zupełnie nowego produktu
               o nieznanym dotąd poziomie użytkowym. Zakres rzeczowy projektu obejmuje nakłady inwestycyjne związane
               z zakupem następujących nowych środków trwałych:
               1. Linia technologiczna do produkcji opakowań.
            </p>
            <p>
               Projekt pozwoli znacząco poszerzyć ofertę produktową i technologiczną przedsiębiorstwa, co zostanie osiągnięte drogą
               praktycznego zastosowania innowacyjnych rozwiązań w zakresie produkcji opakowań papierowych o unikalnej konstrukcji
               i podwyższonych walorach użytkowych.Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą
               inwestycji technologicznej polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food."
            </p>
            <p>
               Wartość projektu : 10 380 499,20 PLN<br />
               Wkład Funduszy Europejskich : 4 671 224,66 PLN
            </p>
          </div>*/}
			<Row>
				<Col className="center title">
					<h2>Certyfikaty</h2>
				</Col>
			</Row>

         
            <Row>
               <Col>
                  <SimpleReactLightbox>
                     <SRLWrapper>
                        <img src="13920_FSMS_recert_cert_english-1.jpg" alt="" className="image-cert" />
                        <img src="13920_FSMS_recert_cert_english-2.jpg" alt="" className="image-cert-none" />
                     </SRLWrapper>
                  </SimpleReactLightbox>
               </Col>
               <Col>
                  <SimpleReactLightbox>
                     <SRLWrapper>
                        <img src="13920__FSMS_recert_cert_polish-1.jpg" alt="" className="image-cert" />
                        <img src="13920_FSMS_recert_cert_polish-2.jpg" alt="" className="image-cert-none" />
                     </SRLWrapper>
                  </SimpleReactLightbox>
               </Col>
            </Row>

            <Row>
               <Col>
                  <SimpleReactLightbox>
                     <SRLWrapper>
                        <img src="BRC Packaging Certificate_Hadepol_2022-1.jpg" alt="" className="image-cert" />
                     </SRLWrapper>
                  </SimpleReactLightbox>
               </Col>
               <Col>
                  <SimpleReactLightbox>
                     <SRLWrapper>
                        <img src="BRC Packaging Certyfikat_PL_HADEPOL_2022-1.jpg" alt="" className="image-cert" />
                     </SRLWrapper>
                  </SimpleReactLightbox>
               </Col>
            </Row>

            <Row>
               <Col>
                  <SimpleReactLightbox>
                     <SRLWrapper>
                        <img src="Certyfikat_W.jpg" alt="" className="image-cert" />
                     </SRLWrapper>
                  </SimpleReactLightbox>
               </Col>
               <Col>
                  <SimpleReactLightbox>
                     <SRLWrapper>
                        <img src="pefc.jpg" alt="" className="image-cert" />
                     </SRLWrapper>
                  </SimpleReactLightbox>
               </Col>
            </Row>

            
         
        </section>
	);

export default CertificatesPage;